import Vue from 'vue'
import VueRouter from 'vue-router'
import BaseLayout from '../layouts/base.vue'
import DashboardLayout from '../layouts/dashboard.vue'

import loginPage from '../pages/login.vue'
import hostPage from '../pages/host.vue'

import DashboardHome from '../pages/dashboard/index.vue'
import DashboardSchedule from '../pages/dashboard/schedule.vue'
import DashboardMessage from '../pages/dashboard/messages.vue'
import DashboardView from '../pages/dashboard/view.vue'
import DashboardSettings from '../pages/dashboard/settings.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: BaseLayout,
    name: 'base-route',
    children: [
      {
        path: 'login',
        component: loginPage,
        name: 'login' 
      },
      {
        path: 'host',
        component: hostPage,
        name: 'host' 
      }
    ]
  },
  {
    path: '/dashboard/',
    component: DashboardLayout,
    children: [
      {
        path: '',
        component: DashboardHome,
        name: 'dashboard-home',
        meta: {
          title: "home"
        },
      },
      {
        path: 'schedule',
        component: DashboardSchedule,
        name: 'dashboard-schedule',
        meta: {
          title: "schedule"
        },
      },
      {
        path: 'message',
        component: DashboardMessage,
        name: 'dashboard-message',
        meta: {
          title: "message"
        },
      },
      {
        path: 'settings',
        component: DashboardSettings,
        name: 'dashboard-settings',
        meta: {
          title: "settings"
        },
      },
      {
        path: 'view',
        component: DashboardView,
        name: 'dashboard-view',
        meta: {
          title: "View message"
        },
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
